// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle_cNiTj[disabled] {
  opacity: 0.5;
}

.toggle_cNiTj[data-error] {
  border: 1px solid var(--color-danger500) !important;
  color: var(--color-danger500) !important;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-video/lib/player/actions/PTZPresetsAction.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,mDAAmD;EACnD,wCAAwC;EACxC,UAAU;AACZ","sourcesContent":[".toggle[disabled] {\n  opacity: 0.5;\n}\n\n.toggle[data-error] {\n  border: 1px solid var(--color-danger500) !important;\n  color: var(--color-danger500) !important;\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggle": `toggle_cNiTj`
};
export default ___CSS_LOADER_EXPORT___;
